<div>
    <div class="about-modal-header" fxLayout="row" fxLayoutAlign="space-between center">
        <div></div>
        <div>
            <button mat-icon-button (click)="close()" id="am-1356">
                <mat-icon class="font-size-24 line-height-24">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="about-modal-body">
        <div *ngIf="siteLogo" class="about-modal-logo mb-12">
            <img [src]="_DomSanitizer.bypassSecurityTrustUrl(siteLogo)" alt="Site Logo" id="am-1357" />
        </div>

        <p class="p-0 mt-0 ml-0 line-height-28 site-title mr-0 mb-0 ml-0 font-size-28">{{ "Laderach" | translate }}</p>
        <p class="m-0 p-0 font-size-10 calibri-font-regular secondary-text-color-two" *ngIf="version">{{ version }}</p>
        <p class="m-0 p-0 font-size-10 calibri-font-regular secondary-text-color-two" *ngIf="!version">
            v1.0.0.05272019
        </p>
        <div class="pt-80 pb-80 copyright">
            <p class="font-size-16 line-height-16 pt-0 pl-0 pr-0 m-0 font-weight-100">
                &copy; {{ "Laderach" | translate }} {{ fullYear }}. {{ "ALL_RIGHTS_RESERVED" | translate }}
            </p>
            <div class="separator"></div>
            <p class="font-size-16 line-height-20 pt-8 pl-0 pr-0 pb-0 m-0 font-weight-100">
                {{ "TECHNOLOGY_DESIGN" | translate }}
                <a href="https://selise.ch/" target="_blank">SELISE rockin' software</a>
            </p>
        </div>
    </div>
    <!-- <div class="about-modal-footer p-16 h-56">
    <div class="about-footer-links">
      <span>
        <a href="{{termsCondition1}}" target="_blank" class="cursor-pointer">{{'IMPRESSUM' | translate}}</a>
      </span>|
      <span>
        <a href="{{termsCondition2}}" target="_blank" class="cursor-pointer">{{'DATA_PRIVACY' | translate}}</a>
      </span>|
      <span>
        <a href="{{termsCondition3}}" target="_blank" class="cursor-pointer">{{'LEGAL' | translate}}</a>
      </span>
    </div>
  </div> -->
</div>
